/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { ContactInformation } from './ContactInformation';
import {
    ContactInformationFromJSON,
    ContactInformationFromJSONTyped,
    ContactInformationToJSON,
    ContactInformationToJSONTyped,
} from './ContactInformation';

/**
 * 
 * @export
 * @interface NewCourierUser
 */
export interface NewCourierUser {
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    email?: string;
    password?: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof NewCourierUser
     */
    addresses?: Array<Address>;
    /**
     * 
     * @type {ContactInformation}
     * @memberof NewCourierUser
     */
    contactInformation?: ContactInformation;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    trnNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewCourierUser
     */
    createdOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewCourierUser
     */
    lastUpdatedOn?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NewCourierUser
     */
    isProfileSet?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof NewCourierUser
     */
    points?: number;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    couponCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewCourierUser
     */
    isBusiness?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof NewCourierUser
     */
    isStaff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof NewCourierUser
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NewCourierUser
     */
    deletedOn?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NewCourierUser
     */
    subscribedToCommunication?: boolean;
    /**
     * 'delivery', 'pickup' or 'call_first'.
     * @type {string}
     * @memberof NewCourierUser
     */
    deliveryPreference?: string;
    /**
     * Set when an admin chose deliveryPreference on the create form; unset
     * leaves the customer "not chosen".
     * @type {Date}
     * @memberof NewCourierUser
     */
    deliveryPreferenceSetAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    realm?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierUser
     */
    username?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewCourierUser
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NewCourierUser
     */
    referrerId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewCourierUser
     */
    storeLocationId?: number;
    /**
     * Whether this user is a courier/warehouse operator
     * @type {boolean}
     * @memberof NewCourierUser
     */
    isCourier?: boolean;
    /**
     * Business name for courier users
     * @type {string}
     * @memberof NewCourierUser
     */
    businessName?: string;
    /**
     * Customer's answer to "How did you hear about us?" at signup
     * @type {string}
     * @memberof NewCourierUser
     */
    referralSource?: string;
}

/**
 * Check if a given object implements the NewCourierUser interface.
 */
export function instanceOfNewCourierUser(value: object): value is NewCourierUser {
    return true;
}

export function NewCourierUserFromJSON(json: any): NewCourierUser {
    return NewCourierUserFromJSONTyped(json, false);
}

export function NewCourierUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewCourierUser {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(AddressFromJSON)),
        'contactInformation': json['contactInformation'] == null ? undefined : ContactInformationFromJSON(json['contactInformation']),
        'trnNumber': json['trnNumber'] == null ? undefined : json['trnNumber'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'lastUpdatedOn': json['lastUpdatedOn'] == null ? undefined : (new Date(json['lastUpdatedOn'])),
        'isProfileSet': json['isProfileSet'] == null ? undefined : json['isProfileSet'],
        'source': json['source'] == null ? undefined : json['source'],
        'points': json['points'] == null ? undefined : json['points'],
        'couponCode': json['couponCode'] == null ? undefined : json['couponCode'],
        'isBusiness': json['isBusiness'] == null ? undefined : json['isBusiness'],
        'isStaff': json['isStaff'] == null ? undefined : json['isStaff'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deletedOn': json['deletedOn'] == null ? undefined : (new Date(json['deletedOn'])),
        'subscribedToCommunication': json['subscribedToCommunication'] == null ? undefined : json['subscribedToCommunication'],
        'deliveryPreference': json['deliveryPreference'] == null ? undefined : json['deliveryPreference'],
        'deliveryPreferenceSetAt': json['deliveryPreferenceSetAt'] == null ? undefined : (new Date(json['deliveryPreferenceSetAt'])),
        'realm': json['realm'] == null ? undefined : json['realm'],
        'username': json['username'] == null ? undefined : json['username'],
        'emailVerified': json['emailVerified'] == null ? undefined : json['emailVerified'],
        'referrerId': json['referrerId'] == null ? undefined : json['referrerId'],
        'storeLocationId': json['storeLocationId'] == null ? undefined : json['storeLocationId'],
        'password': json['password'] == null ? undefined : json['password'],
        'isCourier': json['isCourier'] == null ? undefined : json['isCourier'],
        'businessName': json['businessName'] == null ? undefined : json['businessName'],
        'referralSource': json['referralSource'] == null ? undefined : json['referralSource'],
    };
}

export function NewCourierUserToJSON(json: any): NewCourierUser {
    return NewCourierUserToJSONTyped(json, false);
}

export function NewCourierUserToJSONTyped(value?: NewCourierUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(AddressToJSON)),
        'contactInformation': ContactInformationToJSON(value['contactInformation']),
        'trnNumber': value['trnNumber'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'lastUpdatedOn': value['lastUpdatedOn'] == null ? undefined : ((value['lastUpdatedOn']).toISOString()),
        'isProfileSet': value['isProfileSet'],
        'source': value['source'],
        'points': value['points'],
        'couponCode': value['couponCode'],
        'isBusiness': value['isBusiness'],
        'isStaff': value['isStaff'],
        'isDeleted': value['isDeleted'],
        'deletedOn': value['deletedOn'] == null ? undefined : ((value['deletedOn']).toISOString()),
        'subscribedToCommunication': value['subscribedToCommunication'],
        'deliveryPreference': value['deliveryPreference'],
        'deliveryPreferenceSetAt': value['deliveryPreferenceSetAt'] == null ? undefined : ((value['deliveryPreferenceSetAt']).toISOString()),
        'realm': value['realm'],
        'username': value['username'],
        'emailVerified': value['emailVerified'],
        'referrerId': value['referrerId'],
        'storeLocationId': value['storeLocationId'],
        'isCourier': value['isCourier'],
        'businessName': value['businessName'],
        'referralSource': value['referralSource'],
    };
}

